import React from 'react'
import { RectangleSkeleton } from '@sainsburys-tech/bolt'

const KlarnaMessagingSkeleton = () => {
  return <RectangleSkeleton height={44} width={350} />
}

export default KlarnaMessagingSkeleton
